// Both Overview panels report on the same plant-local day and Bay selection.
export const DEFAULT_FILTERS = { date: null, selectedBay: null };

export function analyticsQueryArgs({ plantId, date, selectedBay }) {
	return {
		plantId,
		range: "day",
		...(date ? { date } : {}),
		...(selectedBay ? { checkpointNumbers: [selectedBay] } : {}),
	};
}
